import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export default function FullLogo(props: SvgIconProps) {
    return (
        <SvgIcon {...props} viewBox="0 0 241.6 88.3">
            <defs>
                <style type="text/css">
                    {`
                        .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#30408F;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#4DBDC7;}
	.st2{fill:#30408F;}
                    `}
                </style>
            </defs>
            <g id="Слой_x0020_2">
                <polygon className="st0" points="76.5,44.2 84.8,88.3 102,88.3 	" />
                <polygon className="st1" points="73.7,83.8 62.5,24.2 16.5,63.7 	" />
                <polygon className="st0" points="59,13.9 51,0 27.1,41.4 	" />
                <polygon className="st0" points="9.5,71.9 0,88.3 56.4,88.3 	" />
                <polygon
                    className="st2"
                    points="146.9,27.8 159.5,44.2 148.3,44.2 138.7,30.9 138.7,44.2 129.8,44.2 129.8,13 138.7,13 138.7,24.9 
		147.6,13 158.7,13 	"
                />
                <path
                    className="st2"
                    d="M175.8,27.1c1.1,0,2-0.3,2.7-0.8c0.7-0.6,1.1-1.4,1.1-2.5c0-1.1-0.4-1.9-1.1-2.5c-0.7-0.6-1.6-0.9-2.7-0.9
		h-4.4v6.7H175.8z M182.3,33.7l7.6,10.5h-10.4l-6.4-9.6h-1.7v9.6h-8.9V13h14.1c3.9,0,6.9,0.9,8.9,2.8c2,1.9,3,4.4,3,7.6
		c0,2.3-0.5,4.4-1.6,6.3C185.8,31.5,184.3,32.9,182.3,33.7z"
                />
                <polygon className="st2" points="202.9,44.2 194,44.2 194,13 202.9,13 	" />
                <path
                    className="st2"
                    d="M218.8,34.4c1.6,1.6,3.5,2.4,5.8,2.4c2.3,0,4.2-0.8,5.8-2.4c1.6-1.6,2.4-3.5,2.4-5.8c0-2.3-0.8-4.2-2.4-5.8
		c-1.6-1.6-3.5-2.4-5.8-2.4c-2.3,0-4.2,0.8-5.8,2.4c-1.6,1.6-2.4,3.5-2.4,5.8C216.4,30.8,217.2,32.8,218.8,34.4z M212.5,17
		c3.3-3.2,7.4-4.8,12.1-4.8c4.7,0,8.7,1.6,12.1,4.8c3.3,3.2,5,7,5,11.5c0,4.5-1.7,8.4-5,11.5c-3.3,3.2-7.4,4.8-12.1,4.8
		c-4.7,0-8.7-1.6-12.1-4.8c-3.3-3.2-5-7-5-11.5C207.5,24.1,209.2,20.2,212.5,17L212.5,17z"
                />
                <polygon className="st2" points="138.7,79 150.6,79 150.6,87.2 129.8,87.2 129.8,56 138.7,56 	" />
                <path
                    className="st2"
                    d="M166.3,75.3h6.9l-3.4-8.9L166.3,75.3z M173.9,56l12.3,31.2h-8.4l-2-5.2h-12.1l-2,5.2h-9L165.5,56H173.9z"
                />
                <path
                    className="st2"
                    d="M202.5,80.5c3,0,4.5-1,4.5-3c0-2-1.5-3-4.5-3H198v5.9C198,80.5,202.5,80.5,202.5,80.5z M198,62.7v5.2h3.7
		c2.5,0,3.7-0.9,3.7-2.6c0-1.7-1.2-2.6-3.7-2.6C201.7,62.7,198,62.7,198,62.7z M210.6,70.4c1.8,0.4,3.2,1.3,4,2.7
		c0.8,1.4,1.3,2.9,1.3,4.7c0,2.8-1,5-2.9,6.7c-1.9,1.7-4.5,2.6-7.8,2.6h-16V56h13.4c3.6,0,6.5,0.7,8.7,2.1c2.1,1.4,3.2,3.4,3.2,6
		c0,1.5-0.3,2.8-1,4C212.6,69.3,211.7,70,210.6,70.4z"
                />
            </g>
        </SvgIcon>
    );
}
